import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React from "react";
import ShowStatus from "./ShowStatus";
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""
);
const PaymentStatus = () => {
  return (
    <Elements stripe={stripePromise}>
      <ShowStatus />
    </Elements>
  );
};

export default PaymentStatus;
